export const getContentType = (extension?: string): string => {
  if (!extension) return "text/plain; charset=utf-8";
  const ext = extension.toLowerCase();
  switch (ext) {
    case "png":
      return "image/png";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "gif":
      return "image/gif";
    case "bmp":
      return "image/bmp";
    case "svg":
      return "image/svg+xml";
    case "pdf":
      return "application/pdf";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "csv":
      return "text/csv; charset=utf-8";
    case "html":
    case "htm":
      return "text/html; charset=utf-8";
    case "json":
      return "application/json";
    case "xml":
    case "sysml":
      return "application/xml";
    case "txt":
    default:
      return "text/plain; charset=utf-8";
  }
};
